import {defineMessages} from 'react-intl'

export const offerAccessMessages = defineMessages({
  appLocked: {
    id: 'offerAccessFlow.appLocked',
    defaultMessage: 'Book on Vio app'
  },
  signInToBookLabel: {
    id: 'offerAccessFlow.signInToBookLabel',
    defaultMessage: 'Sign in to book'
  }
})
